export const LOCALES = ['en', 'es'] as const;
export type Locale = (typeof LOCALES)[number];

export const DEFAULT_LOCALE: Locale = 'en';

export const LOCALE_LABELS: Record<Locale, string> = {
  en: 'EN',
  es: 'ES',
};

export const LOCALE_NATIVE_NAMES: Record<Locale, string> = {
  en: 'English',
  es: 'Español',
};

/** Flat message catalog — add keys here when introducing new copy. */
export interface Messages {
  'meta.homeTitle': string;
  'meta.homeDescription': string;
  'meta.twitterTitle': string;
  'meta.twitterDescription': string;
  'meta.supportTitle': string;
  'meta.supportDescription': string;
  'meta.printTitle': string;
  'meta.printDescription': string;
  'meta.printMonthTitle': string;
  'meta.printMonthDescription': string;

  'header.subtitle': string;
  'nav.home': string;
  'nav.support': string;
  'nav.menu': string;
  'nav.language': string;

  'footer.rights': string;

  'home.intro': string;
  'home.customMonth': string;
  'home.go': string;

  'print.tip': string;
  'print.invalidUrl': string;
  'print.h1Fallback': string;
  'print.monthHeading': string;

  'printer.configure': string;
  'printer.printCalendar': string;
  'printer.theme': string;
  'printer.grid': string;
  'printer.gridStyle': string;
  'printer.lineWidth': string;
  'printer.lineColor': string;
  'printer.fontColor': string;
  'printer.weekend': string;
  'printer.holiday': string;
  'printer.weekStartsOn': string;
  'printer.showCountryHolidays': string;
  'printer.showSidebar': string;
  'printer.showFootnotes': string;
  'printer.sideNotes': string;
  'printer.footnotes': string;
  'printer.gridRectangle': string;
  'printer.gridRounded': string;
  'printer.gridMinimal': string;
  'printer.monday': string;
  'printer.sunday': string;
  'printer.none': string;
  'printer.canada': string;
  'printer.mexico': string;
  'printer.uk': string;
  'printer.usa': string;

  'support.intro': string;
  'support.cta': string;
  'support.faqHeading': string;
  'support.qMobile': string;
  'support.aMobile': string;
  'support.qPdf': string;
  'support.aPdf': string;
  'support.qTablet': string;
  'support.aTablet': string;

  'months.january': string;
  'months.february': string;
  'months.march': string;
  'months.april': string;
  'months.may': string;
  'months.june': string;
  'months.july': string;
  'months.august': string;
  'months.september': string;
  'months.october': string;
  'months.november': string;
  'months.december': string;

  'weekdays.sun': string;
  'weekdays.mon': string;
  'weekdays.tue': string;
  'weekdays.wed': string;
  'weekdays.thu': string;
  'weekdays.fri': string;
  'weekdays.sat': string;
}

export type MessageKey = keyof Messages;
